import Card, { CardHeader } from "@amzn/meridian/card";
import Column from "@amzn/meridian/column";
import Heading from "@amzn/meridian/heading";
import Link from "@amzn/meridian/link";
import React from "react";
import { getReadableLabel, parseVarianceReason } from "./commonUtils";
import { VarianceReasonFormat } from "./remittanceV2Constants";
import VarianceAmount from "./varianceAmount";

const VarianceCard = ({ variance, width }) => {

    const {reason, type, amount} = variance;

    const issueLink = parseVarianceReason(reason, VarianceReasonFormat.ISSUE_LINK);
    const issueId = issueLink ? issueLink.split('/').pop() : "Ticket Link";
    const reasonCode = parseVarianceReason(reason, VarianceReasonFormat.REASON_CODE);

    return (
        <Card width={width}>
            <CardHeader>
                <Heading>{getReadableLabel(reasonCode)}</Heading>
            </CardHeader>
            <Column spacing="medium">
                <VarianceAmount type={type} amount={amount} />
                {issueLink && <Link href={issueLink} target="_blank" rel="noopener noreferrer">{issueId}</Link>}
            </Column>
        </Card>
    );
};

export default VarianceCard;



// WEBPACK FOOTER //
// ./src/component/common/varianceCard.js